var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canApplePayment)?_c('div',{staticClass:"apple-pay-btn-container"},[_c('div',{staticClass:"apple-pay-button apple-pay-button-black",on:{"click":_vm.setButtonClickListener}},[_vm._v("Apple Pay\n    ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }